import React from 'react';
import clsx from 'clsx';

import ActionCard, { ActionCardVariant } from 'components/Common/Cards/ActionCard';

import GoalProgressCircle from 'components/FinancialCheckup/FinancialDashboard/GoalsSection/GoalProgressCircle';
import RecommendedActions from 'components/FinancialCheckup/FinancialDashboard/GoalsSection/RecommendedActions';
import { Goal, isCreditScoreGoal } from 'components/FinancialCheckup/FinancialDashboard/GoalsSection';
import { getChangeText } from 'components/CreditScoreGauge/CreditScoreGauge';
import { ReactComponent as ArrowUpIcon } from 'images/arrow-up.svg';
import PoweredByEquifax from 'components/FinancialCheckup/FinancialDashboard/PoweredByEquifax';
import HighlightBadge from 'components/HighlightBadge';

import styles from './GoalCard.module.scss';

const GoalCard: React.FC<{
  goal: Goal;
}> = ({ goal }) => {
  const changeText = isCreditScoreGoal(goal) ? getChangeText(goal.changeValue) : null;

  return (
    <ActionCard variant={ActionCardVariant.White}>
      <div className={styles.cardWrapper}>
        <div className={styles.cardContent}>
          {isCreditScoreGoal(goal) && (
            <div className={styles.scoreIqHeader}>
              <p className={styles.scoreIqTitle}>Plannery ScoreIQ*</p>
              <PoweredByEquifax />
            </div>
          )}
          <h3 className={styles.goalName}>{goal.name}</h3>
          <div className={styles.progressSection}>
            <GoalProgressCircle percentage={goal.percentage} type={goal.type} value={+goal.currentValue} />
            <div className={styles.amountSection}>
              <div className={styles.amounts}>
                <span className={styles.currentAmount}>{goal.currentValue}</span>
                {goal.labelText && <span className={styles.targetAmount}>{goal.labelText}</span>}
                {isCreditScoreGoal(goal) && goal.changeValue !== undefined && changeText && (
                  <div
                    className={clsx(styles.changeIndicator, {
                      [styles.changeNegative]: goal.changeValue < 0,
                      [styles.changePositive]: goal.changeValue >= 0,
                    })}
                  >
                    <ArrowUpIcon
                      className={clsx(styles.arrowIcon, { [styles.arrowIconNegative]: goal.changeValue < 0 })}
                    />
                    <span className={styles.changeValue}>{changeText}</span>
                  </div>
                )}
              </div>
              <div className={styles.badge}>
                <span className={styles.badgeEmoji}>{goal.emoji}</span>
                <HighlightBadge customText={goal.badgeText} />
              </div>
            </div>
          </div>
        </div>
        <RecommendedActions actions={goal.actions} />
      </div>
    </ActionCard>
  );
};

export default GoalCard;
